import { queryOptions, useQuery } from '@tanstack/react-query';

import type { Client } from '@/api/core-api/client';

import { participantProfilesControllerFindByUserId } from '@/api/core-api';

import { queryKeys } from './query-keys';

export const profileQueryOptions = (userId: string, client?: Client) =>
  queryOptions({
    queryKey: queryKeys.profile.byUserId(userId),
    queryFn: async () => {
      const response = await participantProfilesControllerFindByUserId({
        client,
        path: { userId },
      });

      if (response.error) {
        throw new Error('Failed to fetch user profile');
      }

      return response.data;
    },
  });

/**
 * Fetch user profile by userId.
 * Use with route context: `const { user } = Route.useRouteContext()`
 * then `useProfile(user.id)`
 */
export function useProfile(userId: string | undefined) {
  return useQuery({
    ...profileQueryOptions(userId ?? ''),
    enabled: !!userId,
  });
}
